import { Redirect, useHistory, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/use-auth';
import PageWrapper from '../../components/PageWrapper';
import { Login } from '../../components/Auth/Login';
import React from 'react';
import { ROUTES } from '../../routing';
import {
  TEAM_LOGIN_VARIANT,
  QUERYPARAM_SHOULD_OPEN_TEST,
} from './loginConstants';

export default function LoginPage({
  isTeamsOnboard = false,
}: {
  isTeamsOnboard?: boolean;
}) {
  const { isAuthenticated } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const { from, variant, companySlug } =
    (location.state as {
      from?: string;
      variant?: TEAM_LOGIN_VARIANT;
      companySlug?: string;
    }) ?? {};

  const returnTo = getReturnToUrl({ flowVariant: variant, from, companySlug });
  const [email, setEmail] = React.useState('');

  const onGoToConfirmEmail = () => {
    history.push(ROUTES.AUTH.CONFIRM_EMAIL.PATH, {
      email,
      returnTo,
    });
  };

  if (isAuthenticated) {
    // toast.error('You are logged in already');
    return <Redirect to={ROUTES.HOME.getPath()} />;
  }

  const title =
    variant === TEAM_LOGIN_VARIANT.TEST
      ? 'Log in to your skills assessment'
      : "Log in to Enki's learning program";

  return (
    <PageWrapper style={{ height: '100vh' }}>
      <Login
        title={title}
        subtitle={
          isTeamsOnboard
            ? 'Make sure to use the email address you were invited with'
            : 'Make sure to use the email address you signed up with'
        }
        goToConfirmEmail={onGoToConfirmEmail}
        redirectUri={`${
          window.location.origin
        }${ROUTES.AUTH.CALLBACK.getPath()}`}
        returnTo={returnTo}
        email={email}
        onEmailChange={(email) => setEmail(email)}
        shouldShowSignupLink={!isTeamsOnboard}
      />
    </PageWrapper>
  );
}

function getReturnToUrl({
  flowVariant,
  from,
  companySlug,
}: {
  flowVariant?: TEAM_LOGIN_VARIANT;
  from?: string;
  companySlug?: string;
}) {
  if (!flowVariant && from) {
    return from;
  }

  if (flowVariant === TEAM_LOGIN_VARIANT.TEST && companySlug) {
    // In non-DF, redirect to home with shouldOpenTest query param
    // The TeamsHome component will handle the redirect to the test
    return ROUTES.HOME.getPath() + `?${QUERYPARAM_SHOULD_OPEN_TEST}=true`;
  }

  return ROUTES.HOME.getPath();
}
